import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { productMessage, waLink, categoryOf, accTypeOf, usesModels } from "@/lib/store";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { AddToCartButton } from "./AddToCartButton";
import { useInterestClick } from "@/lib/cart";

export const InterestAction = ({ p, preferredModel = "" }) => {
  const compat = Array.isArray(p?.compatible) ? p.compatible : [];
  const needsPick = categoryOf(p) === "acessorios" && usesModels(accTypeOf(p)) && compat.length > 1;
  const [model, setModel] = useState("");
  const [warn, setWarn] = useState(false);

  useEffect(() => {
    if (compat.includes(preferredModel)) setModel(preferredModel);
  }, [preferredModel]); // eslint-disable-line react-hooks/exhaustive-deps

  const chosen = needsPick ? model : compat.length === 1 ? compat[0] : "";
  const blocked = needsPick && !model;

  const interest = useInterestClick(p);
  const onClick = (e) => {
    if (!blocked) {
      interest(e);
      return;
    }
    e.preventDefault();
    setWarn(true);
  };
  const checkBlocked = () => {
    if (blocked) setWarn(true);
    return blocked;
  };

  return (
    <div className="flex flex-col gap-2">
      {needsPick && (
        <label className="block">
          <span className={`mb-1.5 block text-xs ${warn && !model ? "text-amber-300" : "text-zinc-400"}`}>
            {warn && !model ? "Escolha o modelo do seu iPhone para continuar" : "Qual é o seu iPhone?"}
          </span>
          <select data-testid={`product-model-pick-${p.id}`} value={model} onChange={(e) => { setModel(e.target.value); setWarn(false); }}
            className={`w-full rounded-full border bg-transparent px-4 py-3 text-sm text-white outline-none transition-colors focus:border-white/50 ${warn && !model ? "border-amber-300" : "border-white/15"}`}>
            <option value="" className="bg-zinc-900">Selecione o modelo…</option>
            {compat.map((m) => <option key={m} value={m} className="bg-zinc-900">{m}</option>)}
          </select>
        </label>
      )}
      <a
        data-testid={`product-interest-btn-${p.id}`}
        data-pid={p.id}
        data-pmodel={p.model}
        href={waLink(productMessage(p, chosen))}
        onClick={onClick}
        target="_blank"
        rel="noopener noreferrer"
        className="group/btn relative inline-flex w-full items-center justify-center gap-2 overflow-hidden rounded-full bg-white px-5 py-3.5 text-sm font-semibold text-black transition-transform duration-300 active:scale-95"
      >
        <span className="absolute inset-0 translate-y-full bg-[#25D366] transition-transform duration-500 ease-out group-hover/btn:translate-y-0" />
        <WhatsAppIcon className="relative h-4 w-4" />
        <span className="relative">Tenho interesse</span>
        <ArrowUpRight className="relative h-4 w-4 transition-transform duration-500 group-hover/btn:rotate-45" />
      </a>
      <AddToCartButton p={p} forModel={chosen} onBlocked={checkBlocked} />
    </div>
  );
};
